document.addEventListener("DOMContentLoaded", function () {
  const allLinks = document.querySelectorAll('nav a');
  const fredSound = document.getElementById("fred-sound");

  allLinks.forEach(link => {
    if (link.textContent.includes("Fred") && link.textContent.includes("4th of July")) {
      console.log("🦅 Fred-Button erkannt!");

      link.addEventListener("click", function () {
        // Explosionseffekt
        link.classList.add("fred-explode");

        // Soundeffekt
        if (fredSound) {
          fredSound.currentTime = 0;
          fredSound.play();
        }

        // Nach 600ms zurücksetzen
        setTimeout(() => {
          link.classList.remove("fred-explode");
        }, 600);
      });
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const fredSound = document.getElementById("fred-sound");

  // Prüfe, ob die aktuelle Seite Freds Kollektion ist
  if (window.location.href.includes("bold-free-fred") && fredSound) {
    // Delay bis DOM ganz geladen ist
    setTimeout(() => {
      fredSound.muted = false;
      fredSound.currentTime = 0;
      fredSound.play().catch(err => {
        console.warn("Fred’s battle cry was blocked 😅:", err);
      });
    }, 500);
  }
});

